const getCTAState = (toCompareProducts, NUMBER_OF_CARDS, selectedTransmissionKey) => {
  const productLength = toCompareProducts?.length === NUMBER_OF_CARDS;
  const isCurrentProductIncluded = toCompareProducts?.some(item => item.detId === selectedTransmissionKey);

  const isDisabled = productLength && !isCurrentProductIncluded;

  return isDisabled;
};

export default getCTAState;
